import { Box, Divider, Image, SkeletonLoader, Typography } from "@drone-js/core";
import { replaceCms } from "apps/commons/functions/replaceCms";
import type { PropertyCardItem } from "libs/codegen/homes-onbaording";
import type { FunctionComponent } from "react";
import { useStaticDataAtomValue } from "../staticDataAtom";
import { PropertyBadge } from "./PropertyBadge";
import type { UnifiedPropertyCardItem } from "./useCompletePagePropertyViewModel";

// Accept both the original PropertyCardItem and the unified version
type PropertyContentProps = PropertyCardItem | UnifiedPropertyCardItem;

export const PropertyContent: FunctionComponent<PropertyContentProps> = (props) => {
    const { isPublishing, name, imageUrl, id, location } = props;

    const {
        cmsData: {
            complete: { onboardingIdLabelText, unnamedPropertyText },
        },
    } = useStaticDataAtomValue();
    const badge = <PropertyBadge publishing={isPublishing} />;
    const displayName = name || unnamedPropertyText;

    const idLabelText = onboardingIdLabelText;

    return (
        <Box display="flex" alignItems="center">
            <Box
                flexShrink={0}
                me="16"
                width="64px"
                height="64px"
                borderRadius="8"
                overflow="hidden"
                position="relative"
                backgroundColor="base.inset"
            >
                <SkeletonLoader label={displayName} shape="rectangle" width="64px" height="64px" />
                <Box position="absolute" top={0}>
                    <Image
                        src={imageUrl}
                        width="64px"
                        height="64px"
                        loading="lazy-blur"
                        borderRadius="8"
                        alt={displayName}
                    />
                </Box>
            </Box>
            <Box width="100%" wordBreak="break-all">
                <Box display="flex" alignItems="center" justifyContent="space-between" qM={{ display: "none" }}>
                    {badge}
                </Box>
                <Typography variant="body-default" textColor="base.default" lineClamp={2}>
                    {displayName}
                </Typography>
                <Box display="flex" alignItems="center" pt="4" qM={{ display: "flex" }}>
                    <Box display="none" qM={{ display: "flex" }}>
                        {badge}
                        <Box height="16px" px="8">
                            <Divider direction="vertical" />
                        </Box>
                    </Box>
                    <Box display="none" qM={{ display: "flex" }}>
                        <Typography variant="body-s" textColor="base.subtle" lineClamp={1}>
                            {replaceCms(idLabelText, id)}
                        </Typography>
                        <Box height="16px" px="8">
                            <Divider direction="vertical" />
                        </Box>
                    </Box>
                    <Typography variant="body-s" textColor="base.subtle" lineClamp={1}>
                        {location}
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};
